export default {
  home: {
    lang: '中',
    lang_cn: 'Traditional Chinese',
    lang_en: 'English',
    form_title:'[Asia Coffee Music Festival x V23 First Debut | March 6-8]',
    form_title2:'Register now',
    submit:'Submit',
    mandatory:'Mandatory',
    yes:"Yes",
    no:"No",
    sales: 'Sales Follow',
    rightSales:"Please select a sales consultant",
    lastName:'Last name',
    firstName:'First name',
    enterLastName:'Please enter your last name',
    enterFirstName:'Please enter your first name',
    emailAddress:'Email address',
    enterEmail:'Please enter your email',
    rightEmail:'Please enter the correct email address!',
    mobileNumber:'Mobile number',
    privacyPolicy:"I/We agree with the use of my/our personal data by KLM,its affiliates, subsidiaries and associated companies for direct marketing purposes in accordance with the Personal Information Collection Statement and the Privacy Policy Statement.",
    appellation:'Title',
    selectAppellation:'Please select a title',
    corporateClient:'Corporate client',
    selectLanguage:'Select language',
    pleaseSelectLanguage:'Please select language',
    InformationSubmitted:'It has been submitted, thank you!',
    submitted_: 'Thank you, you have successfully submitted',
    pleaseWriteName:'company name',
    pleaseWriteName_:'If so, please provide the company name',
    agree_:'I/We have read and agree to the',
    statement_:'Personal lnformation Collection Statement',
    policy_:'Privacy Policy Statement',
    and:' and ',
    corporateClient_:'Please select a corporate customer',
    _policy:'Please check “privacy policy”',
    remark:'Remark',
    fullStop:'.',
    back:'Back',
    submitFail: 'Submit failed, please submit again',
    
    vw: 'WeChat Number',
    enterVw: 'Please enter your WeChat number',

    // enterPhone:'Please enter your mobile number',
    // rightPhone:'Please enter the correct mobile number!',
    
    enterPhoneHK:'Please enter your Hong Kong mobile number',
    rightPhoneHK:'Please enter the correct Hong Kong mobile number!',
    enterPhoneCN:'Please enter your China mobile number',
    rightPhoneCN:'Please enter the correct China mobile number!',
    selectTimeSlot: 'Please select a time slot',
    Yes: 'Yes',
    No: 'No',
    selectZeekrOwner: 'Please select if you are a Zeekr owner',
  },
  appellation: {
    Sir: 'Mr.',
    lady: 'Mrs.',
    Miss: 'Miss',
    professor: 'professor',
  },
  carOption: {
    cartitle: 'Preferred model',
    car1: 'V23 (RHD)',
    car2: 'V23 Sport (AWD)',
    carModel_:'Please select your preferred model'
  },

  phoneHK: '+852 (Hong Kong)',
  phoneCN: '+86 (China)',


  officialDealer: 'Official Hong Kong Authorised Dealer of Hongqi – Kam Lung Motor Group',
  authorizedDealer: 'Authorised dealer for all Hongqi models (excluding taxis)',


};

